import { basicPath } from '../basicPath';

// Helper function to get the correct API path prefix based on domain
const getFlagsPath = (endpoint) => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    return endpoint ? `${prefix}/flags/${endpoint}` : `${prefix}/flags`;
};

export const fetchFlagsDaterange = (params) => async (dispatch) => {
    const path = getFlagsPath('daterange');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchFlagsIds = (params) => async (dispatch) => {
    const path = getFlagsPath('ids');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchFlagsStatus = (params) => async (dispatch) => {
    const path = getFlagsPath('status');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const createFlag = (params) => async (dispatch) => {
    const path = getFlagsPath('');
    const type = 'post';
    return await basicPath(dispatch, params, path, type);
}

export const updateFlag = (params) => async (dispatch) => {
    const path = getFlagsPath('');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const deleteFlag = (params) => async (dispatch) => {
    const path = getFlagsPath('');
    const type = 'delete';
    return await basicPath(dispatch, params, path, type);
}

export const fetchFlagsKanban = (params) => async (dispatch) => {
    const path = getFlagsPath('kanban');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const updateFlagKanbanStatus = (params) => async (dispatch) => {
    const path = getFlagsPath('kanban-status');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateFlagsKanbanOrder = (params) => async (dispatch) => {
    const path = getFlagsPath('kanban-order');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}